export default __webpack_public_path__ + "static/media/down.e356ceaf.svg";